let OneStepPanel = xClass("OneStepPanel", BasePanel, () => {
    return cc.CSLoader.createNode("cocos/one_step_start_panel.csb")
})
let [OneStepNoTimePanel, OneStepNoTimePanelEvent] = require("activity/OneStepActivity/OneStepNoTimePanel")
OneStepPanel.load = function () {
    return new Promise((resolve, reject) => {
        preloadWithLoading(OneStepPanel.resources, resolve, reject, reject)
    })
}
OneStepPanel.resources = [
    "font/zzgftongxin_40_greenstroke.fnt",
    "font/zzgftongxin_40_aquastroke.fnt",
    "cocos/one_step_start_panel.csb",
    "cocos/one_step_btn_start.csb",
    "cocos/one_step.plist",
]
OneStepPanel.prototype.ctor = function (logic, onCloseCallback) {
    let self = this
    self.quesTitleKey = "clover.text.565"
    self.quesContentKey = "onestep.activity.desc.content"
    BasePanel.prototype.ctor.call(self)
    self.onCloseCallback = onCloseCallback
    self.logic = logic
    self.initUI()
}
OneStepPanel.prototype.initUI = function () {
    let self = this
    
    self.closeBtn = self.getChildByName("btn_close")
    quickBuildUIBUtton(self.closeBtn, () => {
        self.onClose()
    })

    self.startBtn = self.getChildByName("btn_start")
    quickBuildUIGLabelButton(self.startBtn, () => {
        self.onClickStartBtn()
    })
    self.timeNode = self.startBtn.getChildByName("num")
    self.startBtn.setString("立即挑战")
    self.activityTime = self.getChildByName("time")

    let title = self.getChildByName("title")
    let quesBtn = cc.Sprite.createWithSpriteFrameName("uilibrary/btn_prompt_1.png")
    self.addChild(quesBtn)
    quesBtn.setScale(0.7)
    quickBuildUIBUtton(quesBtn, () => {
        self.showQuesPanel()
    })
    quesBtn.setPosition(title.x + title.getContentSize().width / 2 + 37, -40)
    self.quesBtn = quesBtn

    self.redBg = self.startBtn.getChildByName('reddot')
    self.redBg.setPosition(128, 40)
    self.redBg.setScale(0.95)
    self.timeNode.setPosition(103, 58)

    self.buildMixText()
}
OneStepPanel.prototype.buildMixText = function () {
    let self = this
    self.getChildByName("tip").removeFromParent(true)
    let pre = 0.81
    let width = self.getContentSize().width
    self.tips = require("clover/gameGuide/GameGuideAnims").createMixedText(
        getText("onestep.panel.tips"), 
        27, cc.color(247,150,12,255), 
        width * pre
    )
    self.addChild(self.tips)
    self.tips.setPosition(width * (1 - pre) / 2, -420)
}
OneStepPanel.prototype.updateUI = function () {
    let self = this
    let info = OneStepActivityManager.getInstance().getInfo()
    if (info.leftTimes > 0) {
        self.timeNode.setVisible(true)
        self.timeNode.setString(info.leftTimes)
        self.redBg.setVisible(true)
    }else {
        self.timeNode.setVisible(false)
        self.redBg.setVisible(false)
    }

    // let startTime = formatTime2Str2(info.begin)
    let endtime = formatTime2Str2(info.end)
    self.activityTime.setString(`活动时间：即日起 - ${endtime}`)
    self.activityTime.getVirtualRenderer().setDimensions(450, 0)
    self.activityTime.setContentSize(self.activityTime.getVirtualRendererSize())
    self.activityTime.x = (self._contentSize.width - self.activityTime.getContentSize().width) / 2

    let pic = self.getChildByName("pic")
    let picSize = pic.getContentSize()
    let bg = self.getChildByName("inner_bg")
    let size = cc.size(picSize.width + 2 * 13, picSize.height + 2 * 13)
    bg.setContentSize(size)
    bg.x = (self.getContentSize().width - size.width) / 2
    // pic.setPosition((self.getContentSize().width - picSize.width) / 2, bg.y - (size.height - picSize.height) / 2)
    pic.setPosition(bg.x + 14, bg.y - 13)
}
OneStepPanel.prototype.onEnter = function () {
    let self = this
    BasePanel.prototype.onEnter.call(self)
    self.updateUI()
}
OneStepPanel.prototype.onClickStartBtn = function () {
    let self = this
    self.startLevel()
}
let levelId = 100001
OneStepPanel.prototype.canStartLevel = function () {
    let local = Localhost.time()
    let info = OneStepActivityManager.getInstance().getInfo()
    if (local >= info.end) {
        return false
    }
    return true
}
OneStepPanel.prototype.startLevel = function () {}
OneStepPanel.prototype.onClose = function () {
    let self = this
    BasePanel.prototype.onClose.call(self, self.onCloseCallback)
}
OneStepPanel.prototype.showOnTimesPanel = function (callback) {
    let self = this
    OneStepNoTimePanel.load().then(() => {
        let panel = OneStepNoTimePanel.create()
        panel.on(OneStepNoTimePanelEvent.ShareMessage, handler(self, self.onShareMessge))
        panel.popup(true, 1, () => {
            callback && callback()
        })
        panel.on(OneStepNoTimePanelEvent.Close, () => {
            self.updateUI()
        })
    }).catch(() => {
        Toast.make(curryQuickGetErrorText(0), 1, () => {
            callback && callback()
        })
    })
}
OneStepPanel.prototype.onShareMessge = function () {
    let self = this
    if (self.isBusy) {
        return
    }
    self.isBusy = true
    function notBusy() {
        self.isBusy = false
    }
    QQShareUtil.shareOneStep(notBusy, notBusy, notBusy)
}
OneStepPanel.prototype.cleanup = function () {
    BasePanel.prototype.cleanup.call(this)
    ResManager.release(OneStepPanel.resources)
}
OneStepPanel.prototype.showQuesPanel = function () {
    let self = this
    if (self.isBusy) {
        return
    }
    self.isBusy = true
    let [quesPanel, quesPanelEvent] = require("clover/panel/CommonQuesPanel")
    quesPanel.show(
        getText(self.quesTitleKey), 
        getText(self.quesContentKey), 
        null, null, (panel) => {
        panel.on(quesPanelEvent.Close, function () {
            panel.onClose()
        })
        panel.on(quesPanelEvent.Sure, function () {
            panel.onClose()
        })
        panel.popup(true, false, () => {
            self.isBusy = false
        })
    })
}
module.exports = OneStepPanel